<template>
    <div class="publicMain1">
        <div class="charts">
            <div class="charts-item">
                <div class="charts-title">养老服务机构统计</div>
                <div ref="chart" id="chart" style="width:100%;height:calc(100% - 40px)"></div>
            </div>
            <div class="charts-item">
                <div class="charts-title">房型统计</div>
                <div ref="chart" id="chart1" style="width:100%;height:calc(100% - 40px)"></div>
            </div>
            <div class="charts-item">
                <div class="charts-title" style="height: 18px"></div>
                <div ref="chart" id="chart2" style="width:100%;height:calc(100% - 40px)"></div>
            </div>
        </div>
        <div class="head">服务量统计</div>
        <div class="head-context">
            <div class="head-context-select">
                <el-radio-group v-model="radio1">
                    <el-radio-button label="居家养老"></el-radio-button>
                    <el-radio-button label="机构养老"></el-radio-button>
                    <el-radio-button label="社区养老"></el-radio-button>
                </el-radio-group>
            </div>
            <div class="head-context-time">

                <span class="head-context-time-item" :class=" index==0?'select':''"  @click="select(0)">今日</span>
                <span class="head-context-time-item" :class=" index==1?'select':''" @click="select(1)">本周</span>
                <span class="head-context-time-item" :class=" index==2?'select':''" @click="select(2)">本月</span>
                <span class="head-context-time-item" :class=" index==3?'select':''" @click="select(3)">全年</span>
                    <el-date-picker
                            v-model="value1"
                            type="daterange"
                            range-separator="至"
                            start-placeholder="开始日期"
                            end-placeholder="结束日期">
                    </el-date-picker>
            </div>
        </div>
        <div class="head-charts">
            <div id="myChart"></div>
        </div>
        <div class="box">
            <div class="box-item box-item1">总运营补贴<span style="font-size: 28px;margin: 0px 10px">0</span>万元</div>
            <div class="box-item box-item2">总护理补贴<span style="font-size: 28px;margin: 0px 10px">0</span>万元</div>
            <div class="box-item box-item3">总建设补贴<span style="font-size: 28px;margin: 0px 10px">0</span>万元</div>
        </div>
    </div>
</template>

<script>

    import {institutionStatistics} from "./api";

    export default {
        data() {
            return {
                radio1: '居家养老',
                value1:'',
                index:0,
            };
        },
        methods: {
            draw1() {
                // 基于准备好的dom，初始化echarts实例
                let that = this
                let chart = this.$echarts.init(document.getElementById("chart1"));
                // 绘制图表
                chart.setOption({
                    tooltip: {
                        trigger: "item",
                        formatter: "{a} <br/>{b}: {c} ({d}%)"
                    },
                    // legend: {
                    //   orient: "vertical",
                    //   right: 100,
                    //   data: ["直接访问", "邮件营销", "联盟广告", "视频广告", "搜索引擎"]
                    // },
                    color: ['rgb(58,160,255)', 'rgb(78,203,155)', 'rgb(250,211,55)'],
                    series: [
                        {
                            name: "访问来源",
                            type: "pie",
                            radius: ["50%", "70%"],
                            avoidLabelOverlap: false,
                            label: {
                                show: true,
                                position: "center",
                                formatter: "{total|" + '机构养老入住率' + "}" + "\n\r" + "\n\r" + "{active|1123}",
                                rich: {
                                    total: {
                                        fontSize: 12,
                                        fontFamily: "微软雅黑",
                                        color: 'rgb(175,175,175)'
                                    },
                                    active: {
                                        fontFamily: "微软雅黑",
                                        fontSize: 26,
                                        color: '#000',
                                        lineHeight: 30,
                                    },
                                }
                            },

                            emphasis: {
                                label: {
                                    show: false,
                                    fontSize: "30",
                                    fontWeight: "bold"
                                }
                            },
                            labelLine: {
                                show: false
                            },
                            data: [
                                {value: 335, name: "直接访问"},
                                {value: 310, name: "邮件营销"},
                                {value: 234, name: "联盟广告"},
                            ]
                        }
                    ]
                });
            },
            draw2() {
                let that  = this
                // 基于准备好的dom，初始化echarts实例
                let chart = this.$echarts.init(document.getElementById("chart2"));
                // 绘制图表
                chart.setOption({
                    tooltip: {
                        trigger: "item",
                        formatter: "{a} <br/>{b}: {c} ({d}%)"
                    },
                    // legend: {
                    //   orient: "vertical",
                    //   right: 100,
                    //   data: ["直接访问", "邮件营销", "联盟广告", "视频广告", "搜索引擎"]
                    // },
                    color: ['rgb(58,160,255)', 'rgb(78,203,155)', 'rgb(250,211,55)'],
                    series: [
                        {
                            name: "访问来源",
                            type: "pie",
                            radius: ["50%", "70%"],
                            avoidLabelOverlap: false,
                            label: {
                                show: true,
                                position: "center",
                                formatter: "{total|" + '救助家庭总数' + "}" + "\n\r" + "\n\r" + "{active|1123}",
                                rich: {
                                    total: {
                                        fontSize: 12,
                                        fontFamily: "微软雅黑",
                                        color: 'rgb(175,175,175)'
                                    },
                                    active: {
                                        fontFamily: "微软雅黑",
                                        fontSize: 26,
                                        color: '#000',
                                        lineHeight: 30,
                                    },
                                }
                            },

                            emphasis: {
                                label: {
                                    show: false,
                                    fontSize: "30",
                                    fontWeight: "bold"
                                }
                            },
                            labelLine: {
                                show: false
                            },
                            data: [
                                {value: that.form.checks, name: "实际入住人数"},
                                {value: that.form.beds, name: "床位数"},
                            ]
                        }
                    ]
                });
            },
            getEchartData() {
                // const chart = this.$refs.chart;
                let that = this
                const myChart = this.$echarts.init(document.getElementById("chart"));
                const option = {
                    title: {
                        text: "",
                        subtext: "",
                        left: "center",
                    },
                    tooltip: {
                        trigger: "item",
                        formatter: "{a} <br/>{b} : {c} ({d}%)",
                    },
                    legend: {
                        orient: "vertical",
                        left: "left",
                        data: ["直接访问", "邮件营销", "联盟广告", "视频广告", "搜索引擎"],
                    },
                    series: [
                        {
                            name: "访问来源",
                            type: "pie",
                            radius: "55%",
                            center: ["50%", "60%"],
                            data: [
                                {
                                    value: that.form.jjyl,
                                    name: "居家养老",
                                    itemStyle: {color: "rgb(58,160,255)"},
                                },
                                {
                                    value: that.form.jgyl,
                                    name: "机构养老",
                                    itemStyle: {color: "rgb(78,203,155)"},
                                },
                                {
                                    value: that.form.sqyl,
                                    name: "社区养老",
                                    itemStyle: {color: "rgb(250,211,55)"},
                                },

                            ],
                            emphasis: {
                                itemStyle: {
                                    shadowBlur: 10,
                                    shadowOffsetX: 0,
                                    shadowColor: "rgba(0, 0, 0, 0.5)",
                                },
                            },
                        },
                    ],
                };
                myChart.setOption(option);
                window.addEventListener("resize", function () {
                    myChart.resize();
                });

                this.$on("hook:destroyed", () => {
                    window.removeEventListener("resize", function () {
                        myChart.resize();
                    });
                });
            },
            drawLine() {
                // 基于准备好的dom，初始化echarts实例
                let myChart = this.$echarts.init(document.getElementById("myChart"));
                // 绘制图表
                myChart.setOption({
                    title: {text: ""},
                    tooltip: {},
                    xAxis: {
                        data: ["第一网格", "第二网格", "第三网格", "第四网格", "第五网格", "第六网格", "第七网格"],
                        textStyle: {
                            color: "akyblue",
                        },
                    },
                    yAxis: {
                        axisLabel: {
                            textStyle: {
                                color: "#999",
                            },
                        },
                    },
                    series: [
                        {
                            name: "销量",
                            type: "bar",
                            data: [5, 20, 36, 10, 10, 20, 20],
                            itemStyle: {
                                normal: {
                                    color: "#4ad2ff",
                                },
                            },
                        },
                    ],
                });
            },
            //点击
            select(e){
                this.index = e
            },
            //请求数据
            getData(){
                institutionStatistics({}).then(res=>{
                    console.log('res',res)
                    this.form=res.content[0]
                    //画eachrts
                    this.$nextTick(() => {
                        this.draw1();
                        this.draw2();
                        this.getEchartData();
                        this.drawLine()
                    });
                })
            }
        },
        mounted() {
            this.getData()

        }
    };
</script>

<style lang="less" scoped>
    .charts {
        display: flex;
        justify-content: space-between;
    }

    .charts-item {
        width: 33%;
        height: 330px;
        margin-top: 30px;
    }

    .charts-title {
        font-weight: 700;
        border-bottom: 1px solid rgb(200, 200, 200);
        margin-left: 52px;
        padding-bottom: 20px;
    }

    .charts-context {
        display: flex;
        height: calc(100% - 40px);
        display: flex;
    }

    .charts-title-left {
        width: 50%;
        height: 100%;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: space-around;
    }

    .charts-title-right {
        width: 50%;
        height: 100%;
        display: flex;
        justify-content: space-around;
        align-items: flex-end;
    }

    .man {
        width: 150px;
        height: 150px;
    }

    .women {
        width: 150px;
        height: 150px;
    }

    .man-context {
        display: flex;
        justify-content: space-between;
    }

    .man-title {
        text-align: center;
        margin: 20px 0px 10px;
    }

    .img {
        width: 70px;
        height: 70px;
    }

    .font {
        width: 70px;
        height: 70px;
        display: flex;
        justify-content: center;
        align-items: center;
        font-size: 24px;
    }

    .charts-title-right-1 {
        height: 60%;
        width: 60px;
        background-color: green;
        position: relative;
        top: -40px;
    }

    .charts-title-right-2 {
        height: 40%;
        width: 60px;
        background-color: rgb(0, 102, 128);
        position: relative;
        top: -40px;
    }

    .charts-percent {
        position: absolute;
        top: -25px;
        right: 15px;
    }

    .charts-title-right-title {
        position: absolute;
        right: 15px;
        bottom: -25px;
    }
    .head {
        border-bottom: 1px solid rgb(200, 200, 200);
        padding-bottom: 10px;
        font-weight: 600;
        margin-left:30px;
    }
    .head-context {
        display: flex;
        justify-content: space-between;
    }
    .head-context-select {
        margin-top: 20px;
        margin-left: 30px;
    }
    .head-context-time {
        margin-top: 20px;
        margin-right: 30px;
    }
    .head-context-time-item {
        margin-right: 20px;
        padding: 4px 8px;
        border-radius: 5px;
        font-size: 14px;

        cursor: pointer;
    }
    .select, .head-context-time-item:hover {
        background-color: rgb(58,161,255);
        color: #FFF;
    }

    #myChart {
        width: 100%;
        height: 300px;
    }
    .box {
        width: 100%;
        height: 120px;
        display: flex;
        box-sizing: border-box;
        justify-content: space-between;
        margin-top: 10px;
        padding: 0px 30px;
    }
    .box-item {
        width: 30%;
        height: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
        border-right: 10px;
        color: #FFF;
        border-radius: 10px;
    }
    .box-item1{
        background-color: rgb(58,161,255);
    }
    .box-item2{
        background-color: rgb(220,181,25);
    }
    .box-item3{
        background-color: rgb(78,203,115);
    }
</style>